import { getInitialPsfsValues } from "../ContactingAPIs/contactingCher";

function createQuestionnaire(questionTypesJson, questionnaireWrapper, pageHeaders) {
    let questionnaire = questionnaireWrapper[0];
    let questions = [];
    let questionnaireQuestionNumber = 1;
    let questionnaireHeaderNumber = 1;
    let page = 1;
    let pageHeadersCount = 0;

    for (let questionType of questionTypesJson) {
        //add page header if there is one
        if (pageHeaders[page - 1] != null && pageHeaders[page - 1] != "") {
            questions[questionnaireQuestionNumber + questionnaireHeaderNumber - 2 + pageHeadersCount] = {
                id: `Page${page}Header`,
                page: page,
                heading: pageHeaders[page - 1],
                answerType: "header",
                name: `Page${page}Header`,
            };

            pageHeadersCount++;
        }

        //add the pages questions
        for (let questionNumber in questionType) {
            questionType[questionNumber]["page"] = page;

            if (questionType[questionNumber]["answerType"] == "header") {
                questionType[questionNumber]["id"] = `Header${questionnaireHeaderNumber}`;
                questionnaireHeaderNumber++;
            } else {
                questionType[questionNumber]["id"] = `Question${questionnaireQuestionNumber}`;
                questionnaireQuestionNumber++;
            }

            questions[questionnaireQuestionNumber + questionnaireHeaderNumber - 3 + pageHeadersCount] =
                questionType[questionNumber];
        }

        page++;
    }

    //add the questions/
    questionnaire["questions"] = questions;

    return [questionnaire];
}

async function createQuestionnaireInitialValues(
    questionnaireInitialValues,
    questionnaireTypeUuid = "",
    answersUuid = "",
    questionnaireUuid = ""
) {
    let initialValues = {};

    questionnaireInitialValues.forEach((element) => {
        Object.assign(initialValues, element);
    });

    let staticValues;
    if (questionnaireTypeUuid == "om6w4") {
        staticValues = await getInitialPsfsValues(answersUuid, questionnaireUuid);
        if (
            staticValues.data && // 👈 null and undefined check
            Object.keys(staticValues.data).length === 0 &&
            Object.getPrototypeOf(staticValues.data) === Object.prototype
        ) {
            staticValues = null;
        }
    }

    if (!!staticValues && staticValues.StatusCode == "200" && staticValues.data) {
        staticValues.data.intialPsfs.map((answer, i) => {
            let json = JSON.parse(answer.RawAnswer);
            if (json && Object.keys(json).length === 0 && Object.getPrototypeOf(json) === Object.prototype) {
                initialValues[`activity${i + 1}`] = "";
                return;
            }
            let textValue = json[`activity${i + 1}`]["text"];
            initialValues[`activity${i + 1}`] = textValue == "{}" ? "" : textValue;
        });
    }
    return initialValues;
}

export { createQuestionnaire, createQuestionnaireInitialValues };
